import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class NiveauService {
  constructor() {
    this.adresse = new AdresseIP()
   this.backendUrl ='/service/api/diplome/authentification/liste-niveau'
   this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }
  getNiveauxByParcours = async (idParcours) => {
  const response = await axios.get(`${this.API_URL}?idParcours=${idParcours}`);
  return response.data;
};

}